import { render, staticRenderFns } from "./gestionVisitas.vue?vue&type=template&id=512fba30&scoped=true"
import script from "./gestionVisitas.vue?vue&type=script&lang=js"
export * from "./gestionVisitas.vue?vue&type=script&lang=js"
import style0 from "./gestionVisitas.vue?vue&type=style&index=0&id=512fba30&prod&scoped=true&lang=css"
import style1 from "./gestionVisitas.vue?vue&type=style&index=1&id=512fba30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512fba30",
  null
  
)

export default component.exports